var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('vertical-form-table', _vm._b({
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "문의종류"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.types,
      "outlined": ""
    },
    model: {
      value: _vm.form.meta.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "type", $$v);
      },
      expression: "form.meta.type"
    }
  })], 1)], 2), _c('terms-of-agreements-short', {
    on: {
      "isValid": function (_isValid) {
        function isValid(_x) {
          return _isValid.apply(this, arguments);
        }
        isValid.toString = function () {
          return _isValid.toString();
        };
        return isValid;
      }(function (isValid) {
        return _vm.isTermsValid = isValid;
      })
    },
    model: {
      value: _vm.form.meta._terms,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "_terms", $$v);
      },
      expression: "form.meta._terms"
    }
  }), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("문의하기")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }